// Customers mutations
import date from '@/mixins/date';
import types from '../../types';

export default {
  [types.STORE_CUSTOMERS]: (state, payload) => {
    state.items = [...state.items, ...payload.items].map((item) => {
      const newItem = item;
      if (item.last_shipment) {
        newItem.last_shipment = date.methods.formatDate(item.last_shipment);
      }
      return newItem;
    });
    state.count = payload.count;
    state.entity = payload.entity;
  },
  [types.STORE_CUSTOMER]: (state, payload) => {
    state.customer = payload.items;
  },
  [types.CLEAR_CUSTOMERS]: (state) => {
    state.items = [];
    state.count = 0;
    state.entity = {};
  },
  [types.CLEAR_CUSTOMER_FROM_STORE]: (state) => {
    state.customer = {};
  },
};
